var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg006Notification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 20H10C10 21.1046 10.8954 22 12 22C13.1046 22 14 21.1046 14 20H20C20.5523 20 21 19.5523 21 19C21 18.4477 20.5523 18 20 18V11C20 6.58172 16.4183 3 12 3C7.58172 3 4 6.58172 4 11V18C3.44772 18 3 18.4477 3 19C3 19.5523 3.44772 20 4 20ZM6 11C6 7.68629 8.68629 5 12 5C15.3137 5 18 7.68629 18 11V18H6V11Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg006Notification);
export default __webpack_public_path__ + "static/media/006-notification.5cb58ef278a3f0c3e367bae73f8d2d3e.svg";
export { ForwardRef as ReactComponent };